import * as React from 'react';

var _rect, _path, _path2, _path3, _path4;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgGoogle = function SvgGoogle(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _rect || (_rect = /*#__PURE__*/ React.createElement("rect", {
        width: 120,
        height: 120,
        fill: "#fff",
        rx: 60
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#4285F4",
        fillRule: "evenodd",
        d: "M97.02 60.886c0-2.765-.248-5.424-.709-7.977h-36.73v15.086h20.988c-.904 4.875-3.652 9.005-7.782 11.77v9.786H85.39c7.374-6.79 11.63-16.787 11.63-28.665",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#34A853",
        fillRule: "evenodd",
        d: "M59.58 99c10.53 0 19.359-3.492 25.811-9.449l-12.604-9.785c-3.492 2.34-7.96 3.722-13.207 3.722-10.157 0-18.755-6.86-21.822-16.078h-13.03v10.105C31.147 90.26 44.335 99 59.58 99",
        clipRule: "evenodd"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#FBBC05",
        fillRule: "evenodd",
        d: "M37.758 67.41A23.4 23.4 0 0 1 36.535 60c0-2.57.443-5.07 1.223-7.41V42.485h-13.03A39 39 0 0 0 20.58 60c0 6.293 1.507 12.25 4.148 17.515z",
        clipRule: "evenodd"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#EA4335",
        fillRule: "evenodd",
        d: "M59.58 36.511c5.726 0 10.867 1.968 14.909 5.833l11.186-11.186C78.92 24.864 70.093 21 59.58 21c-15.245 0-28.434 8.74-34.851 21.486l13.03 10.104c3.066-9.218 11.664-16.079 21.821-16.079",
        clipRule: "evenodd"
    })));
};

export { SvgGoogle as ReactComponent };
//# sourceMappingURL=Google.svg.es.js.map
